import React from "react";
import { RightOutlined } from "@ant-design/icons";

type UserMenuHeaderProps = {
  name: string;
  email?: string;
  onOpenRoles: () => void;
};

/**
 * Identity block at the top of the user menu: who you are, and a way through to
 * your roles.
 *
 * The roles themselves are not listed here. They are granted per trial, so the
 * list has no useful ceiling -- a user with access to a dozen trials can hold
 * more than a dropdown can show. The modal has room to say it properly.
 */
export default function UserMenuHeader({
  name,
  email,
  onOpenRoles,
}: UserMenuHeaderProps) {
  return (
    <div className="px-1 py-1.5 w-[248px]" data-testid="user-menu-header">
      <p className="m-0 text-[#20353E] font-semibold text-sm truncate">
        {name}
      </p>
      {email ? (
        <p className="m-0 text-[#00000073] text-xs truncate" title={email}>
          {email}
        </p>
      ) : null}

      <button
        type="button"
        onClick={onOpenRoles}
        data-testid="user-menu-roles-button"
        className="mt-2 w-full flex items-center justify-between gap-2 rounded-sm border border-[#D9E3E8] bg-white px-2 py-1.5 cursor-pointer text-[#20353E] text-xs hover:bg-[#F0F5F7] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0C7BAA]/40"
      >
        <span>View my roles</span>
        <RightOutlined className="text-[#00000073] text-[10px] shrink-0" />
      </button>
    </div>
  );
}
